import { FC } from 'react';
import { CatButton } from '@blocks-react/components/Button';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { CatContextualMenu } from '@blocks-react/components/ContextualMenu';
import { CatTextPassage } from '@blocks-react/components/TextPassage';
import { CatIconMenuDots } from '@blocks-react/components/Icons/MenuDots';
import { NotificationKebabProps } from '../types';

export const NotificationKebab: FC<NotificationKebabProps> = ({
  handleEventClose,
  title,
  children,
}) => {
  return (
    <CatTooltip onBlTooltipClose={handleEventClose}>
      <CatContextualMenu
        position="bottom-end"
        onBlContextualMenuClose={handleEventClose}
        slot="trigger"
      >
        <CatButton
          slot="trigger"
          variant="ghost"
          hideText
          data-testid="notifications-menubar-button"
        >
          <CatIconMenuDots slot="after" aria-label={title} />
        </CatButton>
        {children}
      </CatContextualMenu>
      <CatTextPassage size="xs">{title}</CatTextPassage>
    </CatTooltip>
  );
};
